import React from "react";
import AutomotiveImg from "../images/m1.jpg";
import PanelDesignImg from "../images/m2.jpg";
import { Wrench, LayoutTemplate } from "lucide-react";

const modules = [
  {
    title: "Automotive 3D Design & Manufacturing",
    img: AutomotiveImg,
    icon: <Wrench className="w-6 h-6 text-white" />,
    description:
      "Learn the basics of 3D design using CAD tools like MCAD and ECAD to create mechanical parts.",
    color: "bg-rose-600",
  },
  {
    title: "Panel Design & Drafting",
    img: PanelDesignImg,
    icon: <LayoutTemplate className="w-6 h-6 text-white" />,
    description:
      "Understand how to design basic mechanical layouts and enclosure panels for industrial applications.",
    color: "bg-orange-500",
  },
];

const MechanicalModules = () => {
  return (
   
      <div className="max-w-6xl mx-auto">
        {/* Heading */}
        <h2 className="text-3xl sm:text-4xl font-bold text-sky-800 text-center mb-12">
          Mechanical Internship Modules
        </h2>

        {/* Module Cards */}
        <div className="grid gap-10 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {modules.map((mod, index) => (
            <div
              key={index}
              className="relative bg-white rounded-xl shadow-lg hover:shadow-2xl transition duration-300 group"
            >
              {/* Image */}
              <div className="overflow-hidden rounded-t-xl">
                <img
                  src={mod.img}
                  alt={mod.title}
                  className="w-full h-48 object-cover transform group-hover:scale-105 transition duration-300"
                />
              </div>

              {/* Icon Badge */}
              <div
                className={`absolute -top-5 left-5 p-3 rounded-full shadow-md ${mod.color}`}
              >
                {mod.icon}
              </div>

              {/* Text Content */}
              <div className="p-6">
                <h3 className="text-lg font-bold text-gray-800 mb-2">{mod.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {mod.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
  
  );
};

export default MechanicalModules;
